import React, { Suspense } from 'react';

const SuspenseWrapper = ({ children }) => {
  // this is for previous lodaing
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {children}
    </Suspense>
  );
};

export default SuspenseWrapper;
